<section
  [ngClass]="{
    'col-f md-col-3-10': currentStep().id === BOOKING_STEPS.PURCHASE_REVIEW.id,
    'ms-large-t': isTabletDown(),
    'pr-large-y': !isTabletDown(),
  }"
  class="flex flex--center flex--space-between relative fill"
>
  @for (step of breadcrumbs(); track $index; let i = $index, isLast = $last) {
    <div
      class="step flex relative grow flex--center flex--grow"
      [class.no-grow]="isLast && !isTabletDown()"
      [class.flex--column]="isTabletDown()"
    >
      <div class="step-content flex flex--center flex--column">
        <fcom-icon-button
          class="tooltip-button"
          [size]="IconButtonSize.LARGE"
          [theme]="
            isLegacy()
              ? step.active
                ? IconButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE
                : IconButtonTheme.LIGHT_SECONDARY_OUTLINE
              : IconButtonTheme.TERTIARY_GHOST
          "
          [icon]="{ name: i < activeIndex() && !isTabletDown() ? SvgLibraryIcon.CHECKMARK : step.icon }"
          [disabled]="step.disabled || i > activeIndex()"
          [aria]="{
            label: step.name,
            labelledby: step.name + '-title',
          }"
          (clickBtn)="onBreadcrumbClick(step, i)"
          (pointerdown)="handleDisabledClick($event, step, i)"
          [dataTestId]="'booking-stepper-' + step.name"
        />

        @if (!isTabletDown()) {
          <div
            [class.medium-type]="step.active && isLegacy()"
            [class.bold-type]="step.active && !isLegacy()"
            [ngClass]="
              i > activeIndex() ? 'grey-600-text text-icon-disabled-text' : 'nordic-blue-900-text text-icon-primary'
            "
            class="step-title font-body-1 ms-xsmall-t absolute nowrap font-body-medium"
          >
            {{ step.name }}
          </div>
        }
      </div>
      @if ((isTabletDown() && i < breadcrumbs().length) || (!isTabletDown() && i < breadcrumbs().length - 1)) {
        <div
          class="progress-connector flex--self-start"
          [style.width.%]="isTabletDown() ? 100 : 0"
          [ngClass]="{
            'ms-medium-y': isTabletDown(),
            'border-all ms-large-t ms-small-x': !isTabletDown(),
            'border-radius-left': isTabletDown() && i === 0,
            'border-radius-right': isTabletDown() && i === breadcrumbs().length - 1,
            'nordic-blue-900-bg surface-contrast': i < activeIndex() || (isTabletDown() && step.active),
            'grey-200-bg surface-disabled': !(i < activeIndex() || (isTabletDown() && step.active)),
          }"
        ></div>
      }
    </div>
  }
</section>
